import { Box, CheckFilledIcon } from '@iheartjane/reefer';
import type { IconSize } from '@iheartjane/reefer';

import styles from './borderedCheckFilledIcon.module.css';

export const BorderedCheckFilledIcon = ({
  size = 'sm',
  ...boxProps
}: { size?: IconSize } & React.ComponentProps<typeof Box>) => {
  return (
    <Box position="absolute" {...boxProps}>
      <CheckFilledIcon className={styles['icon']} size={size} color="primary" />
    </Box>
  );
};
